import React from 'react';
import classnames from 'classnames';
import classes from './Footer.module.scss';
import Logo from '../Logo';
import NextLink from '../NextLink';
import route from '../../constants/routes';
import SocialLinks from '../SocialLinks';
import { FACEBOOK, INSTAGRAM, LINKEDIN, TWITTER, TP } from '../../constants/consts';
import { useTranslation } from '../../src/i18n';

const mainFeaturesLinks = [
  {
    name: `${TP}.m_PERF`,
    link: route.PRODUCTIONS,
  },
  {
    name: `${TP}.m_COMPETITIONS`,
    link: route.COMPETITIONS,
  },
  {
    name: `${TP}.m_SEASON`,
    link: route.SEASONS,
  },
  {
    name: `${TP}.m_OPCOS`,
    link: route.COMPANIES,
  },
  {
    name: `${TP}.m_FESTIVALS`,
    link: route.FESTIVALS,
  },
  {
    name: `${TP}.m_MAPS`,
    link: route.MAPS,
  },
  {
    name: `${TP}.m_ARTICLES`,
    link: route.ARTICLES,
  },
  {
    name: `${TP}.m_FN_REN`,
    link: route.RENTALS,
  },
  {
    name: `${TP}.m_HIGHLIGHTS`,
    link: route.HIGHLIGHTS,
  },
  {
    name: `${TP}.m_STATISTICS`,
    link: route.STATISTICS,
  },
  {
    name: `${TP}.m_ARTIST`,
    link: route.ARTISTS,
  },
];

const proToolsLinks = [
  {
    name: `${TP}.m_PROAO`,
    info: `${TP}.m_FOOTER_FORTHEATRES`,
    link: route.INTRO_AOS,
  },
  {
    name: `${TP}.m_PROAGENT`,
    info: `${TP}.m_FOOTER_FORMANAGERS`,
    link: route.INTRO_AGENTS,
  },
  {
    name: `${TP}.m_PROARTIST`,
    info: `${TP}.m_FOOTER_FORARTISTS`,
    link: route.INTRO_ARTISTS,
  },
  // {
  //   name: `${TP}.FN_FOOTER_ARCHIVE`,
  //   info: `${TP}.FN_FOOTER_FOR_ARCHIVE`,
  //   link: route.INTRO_ARCHIVES,
  // },
];

const socialLinks = [
  { link: FACEBOOK, type: 'facebook' },
  { link: TWITTER, type: 'twitter' },
  { link: INSTAGRAM, type: 'instagram' },
  { link: LINKEDIN, type: 'linkedin' },
];

const policyLinks = [
  {
    name: `${TP}.FN_PRIVPOL`,
    link: route.PRIVACY,
  },
  {
    name: `${TP}.FN_TERMCOND`,
    link: route.TERMS_AND_CONDITIOS,
  },
  {
    name: `${TP}.FN_CPOL`,
    link: route.COOKIE_POLICY,
  },
  {
    name: `${TP}.FN_TERMPAY`,
    link: route.PAYMENT_TERMS,
  },
];

const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className={classes.footer}>
        <div className={classes.section}>
          <div className={classes.title}>
            <Logo />
          </div>
          <div className={classes.sectionContent}>
            {t(`${TP}.m_FOOTER_DESCRIPTION`)}
            <span className={classes.moreLink}>
              <NextLink href={route.INTRO_OB}>{t(`${TP}.m_INTRODUCTION`)}</NextLink>
            </span>
          </div>
          <SocialLinks socialLinks={socialLinks} />
        </div>

        <div className={classnames(classes.section, classes.noMobile)}>
          <h5 className={classes.title}>{t(`${TP}.m_FOOTER_MAINFEATURES`)}</h5>
          <div className={classes.linksBlock}>
            {mainFeaturesLinks.map(link => (
              <div className={classes.sectionLink} key={link.link}>
                <NextLink href={link.link}>{t(link.name)}</NextLink>
              </div>
            ))}
          </div>
        </div>

        <div className={classnames(classes.section, classes.noMobile)}>
          <h5 className={classes.title}>{t(`${TP}.m_FOOTER_NEWANDRARE`)}</h5>
          <div className={classes.sectionContent}>{t(`${TP}.m_FOOTER_NEWANDRARE_DESC`)}</div>
          <NextLink href={route.NEW_RARE}>{t(`${TP}.m_FOOTER_GOTOLISTING`)}</NextLink>
        </div>

        <div className={classes.section}>
          <h5 className={classes.title}>{t(`${TP}.m_SIDEBAR_INTRO`)}</h5>
          {proToolsLinks.map(link => (
            <div className={classes.sectionContent} key={link.link}>
              <NextLink href={link.link}>{t(link.name)}</NextLink> {t(link.info)}
            </div>
          ))}
        </div>
        <div className={classes.linkWrapper}>
          {policyLinks.map((link, index) => (
            <div className={classes.inlineLinks} key={link.link}>
              <NextLink href={link.link}>{t(link.name)}</NextLink>
              {index !== policyLinks.length - 1 && <span className={classes.delimiter}>|</span>}
            </div>
          ))}
        </div>
      </div>
      <div className={classes.OBLtd} />
    </>
  );
};

export default Footer;
